import { PATHNAMES_NOT_IN_BOOKING_FLOW } from '@/utils/constants'

export const isPathnameInBookingFlow = (pathname: string): boolean => {
  return !PATHNAMES_NOT_IN_BOOKING_FLOW.includes(pathname)
}
